import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [MatMenuModule, MatButtonModule, MatIconModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss'
})
export class UserAvatarComponent {
  @Input() name: string = '';
  @Input() initials: string = '';
  @Input() username: string = '';
  @Input() role: string = '';
  @Output() logoutRequest = new EventEmitter<void>();
  isMenuOpen = false;

  onLogoutClick() {
    this.logoutRequest.emit(); 
  }
}
